import styles from "../createGame.module.css";
import { translate } from "../../../../translations/index";
import { TextField } from "@material-ui/core";

export default function NameAndTypeStep({ template, setTemplate }) {
  const setName = (e) => {
    setTemplate({
      ...template,
      name: e.target.value,
    });
  };

  return (
    <section className={styles.firstContainer}>
      <div>
        <label className={styles.nameInstruction} htmlFor="gameTemplate_name">
          {translate("teacher.gameSettings.steps.name.label")}
        </label>
        <TextField
          fullWidth
          value={template.name}
          name="gameTemplate[name]"
          id="gameTemplate_name"
          autoFocus
          onChange={setName}
          placeholder={translate("teacher.gameSettings.steps.name.placeholder")}
        />
      </div>
    </section>
  );
}
